<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" v-if="getPermission('ymsSubsidyAutoRule_inset')"
        @click="$refs['addSubsidyRules'].initAddSubsidyRulesData('addParent', 'add')">
        {{ $t('key1005124') }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        row-key="autoRuleId"
        highlight-row
        border
        draggable
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-drag-drop="dragDrop">
      </Table>
    </div>
    <!--创建补贴规则弹窗-->
    <addSubsidyRulesModal
      ref="addSubsidyRules"
      :subsidyAmountTypeList="subsidyAmountTypeList"
      :deliveryMethodList="deliveryMethodList"
      :typeValueList="typeValueList"
      :subsidyTypeList="subsidyTypeList"
      :subsidyObjectList="subsidyObjectList"
      :originalConditionTypeData="originalConditionTypeData"
      @updateData="getList()">
    </addSubsidyRulesModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import addSubsidyRulesModal from "@/views/yms/components/marketingManage/addSubsidyRulesModal.vue";
import {amountHandel, setConfigCharacters} from "@/utils/common";

export default {
  name: "subsidyRules",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tableColumns: [
        {
          title: 'No.',
          key: 'index',
          width: 65,
          align: 'center',
          render(h, params) {
            let parentAutoRuleId = params.row.parentAutoRuleId;
            let index = !parentAutoRuleId ? (params.index + 1) : '';
            return h('span', index);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 160,
          align: 'left',
          render: (h, params) => {
            let arr = [
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')
                },
                domProps: {
                  innerHTML: '&#xe68a;'
                },
                class: 'icon iconfont cursor greenColor',
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, v.tableData.length - 1, params.index);
                  }
                }
              }),
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')
                },
                domProps: {
                  innerHTML: '&#xe687;'
                },
                class: 'icon iconfont cursor blueColor',
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, 0, params.index);
                  }
                }
              }),
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 20
                },
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002155')
                },
                style: {
                  marginLeft: '5px',
                  position: 'relative',
                  top: '-2px'
                },
                class: 'cursor-move grayColor'
              })
            ];
            let parentAutoRuleId = params.row.parentAutoRuleId;
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === v.tableData.length - 1) {
              arr.splice(0, 1);
            }
            if (v.tableData.length > 1) {
              return v.getPermission('ymsSubsidyAutoRule_updatePriority') && !parentAutoRuleId ? h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              }, arr) : '';
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005120'),
          key: 'name',
          align: 'left',
          minWidth: 250,
          tree: true
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005121'),
          key: 'ruleStatus',
          align: 'left',
          minWidth: 110,
          render(h, params) {
            let status = params.row.status;
            return h('div', {
              style: {
                color: status === 1 ? 'green' : 'red'
              }
            }, status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003869'),
          key: 'subsidyObject',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let name = '';
            let subsidyObject = params.row.subsidyObject;
            if (subsidyObject) {
              let data = JSON.parse(subsidyObject);
              v.subsidyObjectList.map((item) => {
                if (data.obj.value === item.value) {
                  name = item.name;
                }
              });
            }
            return h('span', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003870'),
          key: 'subsidyType',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let name = '';
            let subsidyType = params.row.subsidyType;
            if (subsidyType) {
              let data = JSON.parse(subsidyType);
              v.subsidyTypeList.map((item) => {
                if (data.obj.value === item.value) {
                  name = item.name;
                }
              });
            }
            return h('span', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003872'),
          key: 'subsidyConditions',
          align: 'left',
          minWidth: 230,
          render(h, params) {
            let ruleItems = params.row.ruleItems || [];
            let subsidyConditionsList = [];
            let list = [];
            let newList = ruleItems.filter((item) => {
              return !['CORE-YPOSR-002', 'CORE-YPOSR-006'].includes(item.ruleCode);
            });
            if (newList.length > 0) {
              newList.map((item) => {
                if (item.ruleItemParams) {
                  item.ruleItemParams.map((ele) => {
                    v.originalConditionTypeData.map((talg) => {
                      if (ele.name === talg.value) {
                        let data = JSON.parse(ele.value);
                        subsidyConditionsList.push({
                          type: ele.name,
                          title: talg.name,
                          symbol: v.typeValueList.filter((j) => {
                            return data.symbol === j.value;
                          })[0].name,
                          value: data.obj.value,
                          shipedTime: data.obj.shipedTime || ''
                        });
                      }
                    });
                  });
                }
              });
              if (subsidyConditionsList.length > 0) {
                let space = ' ';
                subsidyConditionsList.map((k, index) => {
                  let text = '';
                  if (k.type === 'shippingMethod') {
                    let txt = v.deliveryMethodList.filter((item) => {
                      return item.value === k.value;
                    })[0].name;
                    text = (index + 1) + '.' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003873') + txt;
                  }
                  if (k.type === 'supplierMerchantId') {
                    let txt = v.sepCommasFn(k.value);
                    text = (index + 1) + '.' + k.title + '： ' + txt.join('、');
                  }
                  if (k.type === 'shippingEfficiency') {
                    let value = amountHandel(k.value * 100);
                    text = `${index + 1}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003861')}${k.shipedTime}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003862')}${space}${k.title}${space}${k.symbol}${space}${value}%`;
                  }
                  if (k.type === 'goodsQuantity') {
                    text = `${index + 1}.${k.title}${space}${k.symbol}${space}${k.value}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003863')}`;
                  }
                  list.push(h('div', {
                    class: 'mt5 mb5'
                  }, text));
                });
              }
              return h('div', list);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675'),
          key: 'ruleActions',
          align: 'left',
          minWidth: 230,
          render(h, params) {
            let ruleActions = params.row.ruleActions || [];
            let title = '';
            if (ruleActions.length > 0) {
              let values = ruleActions.filter((item) => {
                return item.type === 'ymsSubsidyAutoRule';
              })[0].value;
              let data = JSON.parse(values);
              v.subsidyAmountTypeList.map((item) => {
                if (item.value === data.subsidyAmountType) {
                  title = item.name;
                }
              });
              return data.subsidyAmountType === 0 ? h('p', title) :
                h('div', [
                  h('p', {class: 'mb5 mt5'}, title),
                  data.subsidyAmountType === 1 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003876') + data.subsidyAmountPerOrder + ' ' + v.currencyState) : '',
                  data.subsidyAmountType === 2 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003877') + data.subsidyAmountWithinOneKG + ' ' + v.currencyState) : '',
                  data.subsidyAmountType === 2 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003878') + data.subsidyAmountPerKGOverOne + ' ' + v.currencyState) : '',
                  data.subsidyAmountType === 2 ?
                    h('p', {class: 'mb5 mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003879') + data.subsidyAmountCeilingPerOrder + ' ' + v.currencyState) : '',
                ]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          fixed: 'right',
          align: 'left',
          width: 120,
          render(h, params) {
            let status = params.row.status === 1;
            let autoRuleId = params.row.autoRuleId;
            let parentAutoRuleId = params.row.parentAutoRuleId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsSubsidyAutoRule_update'),
                    clickFn: () => {
                      let txt = parentAutoRuleId ? 'editChild' : 'editParent';
                      v.$refs['addSubsidyRules'].initAddSubsidyRulesData(txt, 'edit', autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005122'),
                    show: !parentAutoRuleId && v.getPermission('ymsSubsidyAutoRule_inset'),
                    clickFn: () => {
                      v.$refs['addSubsidyRules'].initAddSubsidyRulesData('addChild', 'add', autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: !status && v.getPermission('ymsSubsidyAutoRule_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row.status, params.row.autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status && v.getPermission('ymsSubsidyAutoRule_disable'),
                    color: '#FF0000',
                    clickFn: () => {
                      v.enableDisableBtn(params.row.status, params.row.autoRuleId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      originalConditionTypeData: [
        {code: 'CORE-YPOSR-001', value: 'goodsQuantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003855')},
        {code: 'CORE-YPOSR-003', value: 'shippingMethod', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867')},
        {code: 'CORE-YPOSR-004', value: 'shippingEfficiency', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003868')},
        {code: 'CORE-YPOSR-005', value: 'supplierMerchantId', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
        {code: 'CORE-YPOSR-002', value: 'subsidyObject', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003869')},
        {code: 'CORE-YPOSR-006', value: 'subsidyType', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003870')},
      ],
      subsidyObjectList: [
        {value: 'supplier', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295')}
      ],
      subsidyTypeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005123')}
      ],
      typeValueList: [
        {value: 1, name: '≥'},
        {value: 2, name: '>'},
        {value: 3, name: '='},
        {value: 4, name: '<'},
        {value: 5, name: '≤'}
      ],
      deliveryMethodList: [
        {value: 1, name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003859')}`},
        {value: 2, name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003860')}`},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587')},
      ],
      subsidyAmountTypeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003864')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003865')},
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003866')}
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsSubsidyAutoRule_query')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsSubsidyAutoRule_query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                item['_showChildren'] = true;
                if (item.ruleItems) {
                  item.ruleItems.map((ele) => {
                    v.originalConditionTypeData.map((talg) => {
                      if (ele.ruleCode === talg.code) {
                        if (ele.ruleItemParams) {
                          ele.ruleItemParams.map((k) => {
                            if (k.name === talg.value) {
                              item[k.name] = k.value;
                            }
                          });
                        }
                      }
                    });
                  });
                }
              });
              v.tableData = v.listToTree(data);
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 将列表结构转换成树状结构
    listToTree(list) {
      let info = list.reduce((map, node) => (map[node.autoRuleId] = node, node.children = [], map), {});
      return list.filter(node => {
        info[node.parentAutoRuleId] && info[node.parentAutoRuleId].children.push(node);
        return !node.parentAutoRuleId;
      });
    },
    // 启用、停用按钮
    enableDisableBtn(status, autoRuleId) {
      let v = this;
      let url = '';
      let text = '';
      // 停用
      if (status === 1) {
        url = api.put_ymsSubsidyAutoRule_disable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472');
      }
      // 启用
      else {
        url = api.put_ymsSubsidyAutoRule_enable;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473');
      }
      v.axios.put(url + autoRuleId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(text);
          v.getList();
        }
      });
    },
    // 优先级拖拽排序
    dragDrop(a, b) {
      this.tableSort(this.tableData[a].autoRuleId, b, a);
    },
    // 处理拖拽排序
    tableSort(autoRuleId, index, oldIndex) {
      let v = this;
      let obj = {
        currentId: autoRuleId, // 规则ID
        previousId: index ? v.tableData[index].autoRuleId : null, // 前一个
        businessId: v.tableData[oldIndex].businessId
      };
      if (!index && v.tableData.length > 1) {
        obj.nextId = v.tableData[0].autoRuleId;
      }
      if (oldIndex > index) {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index - 1].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      } else {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      }
      v.axios.put(api.put_ymsSubsidyAutoRule_updatePriority, JSON.stringify(obj),
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.getList();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
  },
  components: {
    addSubsidyRulesModal
  }
};
</script>

<style scoped>

</style>